import { useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import { Table } from "./Table";
import { Toast } from "primereact/toast";
import { Form } from "./Form";

export interface ITenderClientCategory {
  id?: number;
  category_Name: string;
  description?: string;
  added_By?: number | null;
  added_On?: string | null;
  updated_By?: number | null;
  updated_On?: string | null;
  isActive: boolean;
}

export const EmptyTenderClientCategory: ITenderClientCategory = {
  id: 0,
  category_Name: "",
  description: "",
  added_By: null,
  added_On: null,
  updated_By: null,
  updated_On: null,
  isActive:true
};

export interface IModel {
  open: boolean;
  singleData: ITenderClientCategory;
}

const TenderClientCategory = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyTenderClientCategory, open: false } as IModel);
  const [reload, setReload] = useState<boolean>(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ singleData: EmptyTenderClientCategory, open: false });
  };

  return (
    <>
      <Table permission={permissions} setModal={setModal} toast={toast} reload={reload} />
      <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};
export default TenderClientCategory;
